import {UserService} from '../services/api/user.service';
import {AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import {Observable} from 'rxjs';

export class UserValidators {

  static uniqueMailValidator(userService: UserService, userId?: number): AsyncValidatorFn {
    return (control: AbstractControl):
      Promise<ValidationErrors | null> |
      Observable<ValidationErrors | null> => {
      if (!control.value || Boolean(control.errors?.required) || Boolean(control.errors?.email)) {
        return new Promise<ValidationErrors | null>(resolve => {
          resolve(null);
        });
      }
      return userService.searchUsers({
        exactMail: control.value,
      }, [], 2, 0)
        .then(page => {
          if (userId === undefined) {
            if (page.content.length === 0) {
              return null;
            }
          } else {
            if (page.content.length === 0) {
              return null;
            } else if (page.content.length === 1 && page.content[0].id === userId) {
              return null;
            }
          }
          return {
            uniqueMail: true,
          };
        });
    };
  }

}
